import { Component, OnInit, Input } from '@angular/core';

import { LocalCombustivel } from "../shared/local.model";

@Component({
    selector: 'app-local-combustivel-list',
    template: require('./local-combustivel-list.component.html')
})
export class LocalCombustivelListComponent implements OnInit {
    @Input() list: LocalCombustivel[] = [];
    @Input() showDisabled: boolean = false;

    constructor() { }

    ngOnInit() {
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/locais/local-combustivel-list/local-combustivel-list.component.ts
 **/